import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE_URL = process.env.REACT_APP_HOST + "/api";

// Devuelve los headers con el id_token de Google para endpoints protegidos.
function authHeaders() {
  const token = cookies.get("id_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

// Normaliza la respuesta de error de axios a un objeto manejable.
function toResult(promise) {
  return promise
    .then((res) => ({ ok: true, status: res.status, data: res.data }))
    .catch((e) => ({
      ok: false,
      status: e.response ? e.response.status : 0,
      data: e.response ? e.response.data : { message: e.message },
    }));
}

// ----- Identidad / verificación de rol en el servidor -----
export const getMe = () =>
  toResult(axios.get(`${BASE_URL}/me`, { headers: authHeaders() }));

// ----- Usuarios -----
// params: { limit, lastKey } para paginación (cursor de DynamoDB).
export const listUsuarios = (params = {}) =>
  toResult(
    axios.get(`${BASE_URL}/usuarios`, {
      headers: { "Content-Type": "application/json" },
      params,
    })
  );

export const createUsuario = (usuario) =>
  toResult(axios.post(`${BASE_URL}/usuarios`, usuario, { headers: authHeaders() }));

export const updateUsuario = (usuario) =>
  toResult(axios.put(`${BASE_URL}/usuarios`, usuario, { headers: authHeaders() }));

export const deleteUsuario = (email) =>
  toResult(
    axios.delete(`${BASE_URL}/usuarios`, {
      headers: authHeaders(),
      data: { email },
    })
  );

// ----- Reservaciones -----
// params: { limit, lastKey } para paginación (cursor de DynamoDB).
export const listReservaciones = (params = {}) =>
  toResult(
    axios.get(`${BASE_URL}/reservaciones`, {
      headers: { "Content-Type": "application/json" },
      params,
    })
  );

export const updateReservacion = (reservacion) =>
  toResult(axios.put(`${BASE_URL}/reservaciones`, reservacion, { headers: authHeaders() }));

export const deleteReservacion = (reservacionId) =>
  toResult(
    axios.delete(`${BASE_URL}/reservaciones`, {
      headers: { "Content-Type": "application/json" },
      data: { reservacionId },
    })
  );

// Alta en lote (reservas recurrentes). opts: { serieId, dryRun }.
// dryRun:true solo valida solapamientos y regresa conflictos, sin guardar nada.
export const bulkSaveReservaciones = (reservaciones, opts = {}) =>
  toResult(
    axios.post(
      `${BASE_URL}/reservaciones/bulk`,
      { reservaciones, serieId: opts.serieId },
      {
        headers: authHeaders(),
        params: opts.dryRun ? { dryRun: true } : {},
      }
    )
  );

// Borrado en lote.
export const bulkDeleteReservaciones = (reservacionIds) =>
  toResult(
    axios.delete(`${BASE_URL}/reservaciones/bulk`, {
      headers: authHeaders(),
      data: { reservacionIds },
    })
  );

// Cancela todas las ocurrencias de una serie recurrente.
export const deleteSerieReservaciones = (serieId) =>
  toResult(
    axios.delete(`${BASE_URL}/reservaciones/serie`, {
      headers: authHeaders(),
      data: { serieId },
    })
  );

// Reservaciones acotadas a un rango de fechas (para la vista calendario).
export const listReservacionesSemana = (fechaInicio, fechaFin) =>
  toResult(
    axios.get(`${BASE_URL}/reservaciones/semana`, {
      headers: { "Content-Type": "application/json" },
      params: { fecha_inicio: fechaInicio, fecha_fin: fechaFin },
    })
  );
